import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-gradient-to-r from-pink-50 to-purple-50/30 py-16 md:py-20 px-4" data-id="element-93">
      <div className="container mx-auto max-w-4xl" data-id="element-94">
        <div className="backdrop-blur-sm bg-white/80 rounded-3xl border border-white/20 shadow-md p-8 md:p-12 text-center" data-id="element-95">
          <div className="w-20 h-20 bg-gradient-to-br from-[#FF4DB8] to-[#FF6EC7] rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg shadow-pink-500/20" data-id="element-96">
            <ShieldCheckIcon className="w-10 h-10 text-white" aria-hidden="true" data-id="element-97" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-98">
            Garantía 72 horas
          </h2>

          <p className="text-lg text-[#6B6B6B] max-w-2xl mx-auto mb-6" data-id="element-99">
            Si no estás satisfecho con los resultados en las primeras 72 horas,
            te devolvemos el 100% de tu inversión. Sin preguntas.
          </p>

          <p className="text-[#6B6B6B]" data-id="element-100">
            Probá el sistema sin riesgo y empezá a generar creativos que venden
          </p>
        </div>
      </div>
    </section>;
}